import { Box, TextField, Typography } from '@mui/material';
import { SurveyV2 } from '@act/shared/data-transfer-objects';
import { FieldErrors } from 'react-hook-form';

interface IPromptEditorProps {
  prompt: SurveyV2.CreatePromptJSONDto;
  onChange: (prompt: SurveyV2.CreatePromptJSONDto) => void;
  errors?: FieldErrors<SurveyV2.CreatePromptJSONDto>;
  fieldPath?: string; // Path to the prompt field in the form (e.g., "surveyContent.surveyVersion.questions.0.prompt")
}

const PromptEditor = ({
  prompt,
  onChange,
  errors,
  fieldPath,
}: IPromptEditorProps) => {
  // Helper function to get nested error messages
  const getFieldError = (fieldName: string) => {
    if (!errors || !fieldPath) return null;

    // Construct the full path to the specific field
    const fullPath = `${fieldPath}.${fieldName}`;

    // Parse nested error path (e.g., "surveyContent.surveyVersion.questions.0.prompt.title")
    const pathParts = fullPath.split('.');
    let error = errors;

    for (const part of pathParts) {
      if (error && typeof error === 'object' && part in error) {
        error = error[part];
      } else {
        return null;
      }
    }

    return error?.root?.message || null;
  };

  const titleError = getFieldError('title');
  const textError = getFieldError('text');

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: '16px',
        margin: '8px 0 24px',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        <Typography variant="bodyLarge">Prompt</Typography>
      </Box>
      <Box>
        <TextField
          label="Title"
          value={prompt.title}
          onChange={e => onChange({ ...prompt, title: e.target.value })}
          fullWidth
          error={!!titleError}
          helperText={titleError}
        />
      </Box>
      <Box>
        <TextField
          label="Text"
          value={prompt.text}
          onChange={e => onChange({ ...prompt, text: e.target.value })}
          multiline
          rows={2}
          fullWidth
          error={!!textError}
          helperText={textError}
        />
      </Box>
    </Box>
  );
};

export default PromptEditor;
